import type { ValueOf } from '@shared/lib'

export const AvatarSize = { sm: 'sm', md: 'md', lg: 'lg' } as const
export type AvatarSize = ValueOf<typeof AvatarSize>
